import React, { useEffect } from "react";
import { APP_RELEASE } from "../version";

// Poll once per mount + every 5 min: if the server's /version.json advertises
// a different release than the bundle we're running, unregister the SW, wipe
// caches and re-navigate with a cache-busting query (?rv=) so the browser's
// HTTP cache can't serve the stale shell. Time-based guard (2 min) instead of
// a permanent per-session block, so one failed attempt never pins the device.
let pollerStarted = false;

export function VersionBadge({ className = "" }) {
  useEffect(() => {
    if (pollerStarted) return;
    pollerStarted = true;
    // tidy the one-time cache-busting param after a successful refresh
    const here = new URL(window.location.href);
    if (here.searchParams.has("rv")) {
      here.searchParams.delete("rv");
      window.history.replaceState(null, "", here.toString());
    }
    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        const data = await res.json();
        if (data.release && data.release !== APP_RELEASE) {
          const guard = `reup-reloaded-${data.release}`;
          const last = Number(sessionStorage.getItem(guard) || 0);
          if (Date.now() - last > 2 * 60 * 1000) {
            sessionStorage.setItem(guard, String(Date.now()));
            try {
              if (navigator.serviceWorker) {
                const regs = await navigator.serviceWorker.getRegistrations();
                await Promise.all(regs.map((r) => r.unregister()));
              }
              if (window.caches) {
                const keys = await caches.keys();
                await Promise.all(keys.map((k) => caches.delete(k)));
              }
            } catch { /* best effort */ }
            const url = new URL(window.location.href);
            url.searchParams.set("rv", data.release);
            window.location.replace(url.toString());
          }
        }
      } catch {
        /* offline — ignore */
      }
    };
    check();
    setInterval(check, 5 * 60 * 1000);
  }, []);
  return (
    <span
      className={`text-[10px] font-medium text-zinc-400 tabular-nums ${className}`}
      data-testid="app-version-badge"
      title="App version"
    >
      {APP_RELEASE}
    </span>
  );
}
